import { query } from '../utilities';

export const personalCashbackRest = (params) => {
    return query('/account/cashback-rest/', params);
};
